import { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import { useAppState } from '../reduxish/appState'
import { readBool, writeBool, STORAGE_KEYS } from '../reduxish/persistence'

export default function AgeGateDialog() {
    const { state } = useAppState()
    const isAuthenticated = state.auth?.isAuthenticated ?? false
    const [open, setOpen] = useState(false)

    // Only gate anonymous visitors. Logged-in users have already been through
    // the sign-up flow, and once a visitor confirms 21+ we remember it in
    // localStorage so the prompt never returns.
    useEffect(() => {
        if (isAuthenticated) {
            setOpen(false)
            return
        }
        if (!readBool(STORAGE_KEYS.ageVerified, false)) {
            setOpen(true)
        }
    }, [isAuthenticated])

    const handleConfirm = () => {
        writeBool(STORAGE_KEYS.ageVerified, true)
        setOpen(false)
    }

    const handleDecline = () => {
        window.location.href = 'https://www.gambleaware.org'
    }

    return (
        <Dialog
            open={open}
            onClose={() => { /* modal — dismissal requires an explicit choice */ }}
            aria-labelledby="age-gate-title"
            aria-describedby="age-gate-description"
        >
            <DialogTitle id="age-gate-title">Age Verification</DialogTitle>
            <DialogContent>
                <DialogContentText id="age-gate-description">
                    Access to this website is strictly restricted to individuals aged 21 and older.
                    The information provided here is intended solely for entertainment and educational
                    review purposes. Please confirm that you are 21 years of age or older to continue.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDecline}>I am under 21</Button>
                <Button onClick={handleConfirm} variant="contained" autoFocus>I am 21 or older</Button>
            </DialogActions>
        </Dialog>
    )
}
